'use client'

import { useComponentTranslation } from '@tebuto/functions/translation.components'

export function PaymentPreviewNotice() {
    const { t } = useComponentTranslation()

    return (
        <div className="rounded-lg border widget-border-primary-200 widget-bg-primary-50 p-3">
            <p className="text-xs widget-text-secondary">{t('booking.preview.paymentNotice')}</p>
        </div>
    )
}
